import * as yup from 'yup'

export const schemaRegistrationDateModal = yup.object().shape({
    registration_date: yup.string().required('Registration date is required'),
})
